
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.508 1.385h6.524M.976 1.047v11.21m-.47-.471l5.628-.024M.508 5.176h6.524M5.216 2.333l8.386-.026m-.442-.451v4.75M5.213 4.237l7.476-.035m-1.442 4.258v6.586m-3.263-3.285l6.522-.023","stroke":"currentColor"}})])
          )
        }
      }
    